module.exports = __webpack_public_path__ + "img/ag.c6c13234.svg";